/* Responsibility: Own sys-panel localStorage persistence for outbound report retries.
Scope: Report queue storage only; feedback submission and other UI flows must not depend on this module. */
export const REPORT_ENDPOINT_KEY = 'am2_report_endpoint_v1'

const REPORT_QUEUE_KEY = 'am2_report_queue_v1'

export function loadReportQueue() {
  try {
    const raw = localStorage.getItem(REPORT_QUEUE_KEY)
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

export function saveReportQueue(list) {
  try {
    localStorage.setItem(REPORT_QUEUE_KEY, JSON.stringify(list.slice(0, 100)))
  } catch {
    // Non-fatal
  }
}
